import React from 'react'
import FavoriteLeagueAPI from '../Profile/FavoriteLeagueAPI'
import './ViewJarallax.css'

function ViewJarallax(props) {
    
    return (

        <div 
            className="view jarallax" 
            data-jarallax='{"speed": 0.2}' 
            style={
                {backgroundImage: 
                `url(${props.image ? props.image 
                :
                "https://progitek.no/privat/bp/wp-content/uploads/2020/08/pexels-tembela-bohle-1884576-1024x683.jpg"})`, 
                backgroundRepeat: "no-repeat", 
                backgroundSize: "cover", 
                backgroundPosition: "center center"}} >
            <div className="mask rgba-black-strong" style={{backgroundColor: "rgba(rgb(0,0,0, 0.5)}"}}>
                <div className="container h-100 d-flex justify-content-center align-items-center">
                    <div className="row pt-5 mt-3">
                        <div className="col-md-12 mb-3">
                        {props.type === "league" && (
                            <div className="py-1 float-right">
                                <FavoriteLeagueAPI leagueId={props.id} league={props.league} color="dark" />
                            </div>
                        )}
                        <div className="intro-info-content text-center">
                            <h2 className="mb-5 wow fadeInDown text-white font-weight-bold" data-wow-delay="0.3s">
                                
                                <span className={"font-weight-bold"}>
                                    {props.logo && <img src={props.logo} alt={props.text} style={{maxWidth: "40px"}} className="img-fluid rounded-circle" />} <span>{props.text}</span>

                                </span>
                            </h2>

                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ViewJarallax